import { Dispatch, SetStateAction, useState } from "react";
import {
  Modal,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { useCancelEventMutation } from "../service/offer";
import { showError, showToast } from "../constants/toasts";
interface RejectReasonModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  selectedReason: string;
  setSelectedReason: Dispatch<SetStateAction<string>>;
  offerId: string | undefined;
  getOfferDetailApi: () => void;
}

export default function CancelEventModal({
  open,
  onClose,
  setOpen,
  selectedReason,
  setSelectedReason,
  offerId,
  getOfferDetailApi,
}: RejectReasonModalProps) {
  const [cancelApi] = useCancelEventMutation();

  const [localReason, setLocalReason] = useState(selectedReason || "Refund");
  const navigate = useNavigate();

  const cancelEventApi = async () => {
    setSelectedReason(localReason); // Update parent only on submit
    try {
      const response = await cancelApi({
        offerId: offerId,
        CancelType: localReason,
      }).unwrap();

      if (response.status === 200) {
        showToast(response?.message || "");
        if (localReason === "Refund") {
          setOpen(false);
          if (response?.data) {
            navigate("/user-table", { state: { offerId: offerId } });
          }
          getOfferDetailApi();
        } else {
          setOpen(false);
          getOfferDetailApi();
        }
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLocalReason(e.target.value); // Local state only
  };

  return (
    <Modal className="modal rejectReason_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Are you sure you want to Cancel?</h2>
            <div
              role="button"
              tabIndex={0}
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </div>
          </div>
          <form className="form">
            <RadioGroup value={localReason} onChange={handleRadioChange}>
              <FormControlLabel
                value="Refund"
                control={<Radio />}
                label="Refund"
              />
              <FormControlLabel
                value="Compensation"
                control={<Radio />}
                label="Compensation"
              />
            </RadioGroup>

            <div className="footer_btn_flex">
              <Button className="btn btn_primary" onClick={cancelEventApi}>
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
